export const BOARD_HEADER_HEIGHT = 88;
export const SCHEDULED_FILTERS_BAR_HEIGHT = 48;
